import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysStockMoveCreateItem(props) {
    const { masterGridSetting } = props;
    const [Api, setApi] = useState();
    const [grid, setGrid] = useState();
    const setNotification = useSetRecoilState(notificationState);

    const { t } = useTranslation();

    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        masterGridSetting(grid.selectedItems[0]);
                    } else {
                        masterGridSetting({});
                    };
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        masterGridSetting(grid.selectedItems[0]);
                    } else {
                        masterGridSetting({});
                    };
                });
            }
        })();
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    return (
        <>
            <BasicCrudScreenType
                id="MomSysVwStockMoveItem"
                table="MomSysVwStockMoveItem"
                view="MomSysVwStockMoveItem"
                onApiInitialized={onApiInitialized}
                onInitialized={onInitialized}
                headerTitle={t("term.item")}
                noCreate
                noEdit
                noDelete
                noExcel
            />
        </>
    );
}

export default MomSysStockMoveCreateItem;
